import { render, staticRenderFns } from "./BannerOurSolutions.vue?vue&type=template&id=68df95a0"
import script from "./BannerOurSolutions.vue?vue&type=script&lang=js"
export * from "./BannerOurSolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
